import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StatusBadge = styled(Badge, { shouldForwardProp: prop => prop !== 'isActive' })<{ isActive: boolean }>(
  ({ isActive }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: isActive ? '#44b700' : '#b2bec3',
      color: isActive ? '#44b700' : '#b2bec3',
      boxShadow: `0 0 0 2px #fff`,
      minWidth: 7,
      height: 7,
      borderRadius: '50%',
      '&::after': isActive
        ? {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.4s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
          }
        : undefined,
    },
    '@keyframes ripple': {
      '0%': { transform: 'scale(.8)', opacity: 1 },
      '100%': { transform: 'scale(2.4)', opacity: 0 },
    },
  }),
);

export const SearchBox = styled(Box)({
  height: 27,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#f4f4f6',
  borderRadius: '64px',
  padding: '6px 12px',
  gap: 6,
  marginBottom: 12,
});
